export const zindex = {
  modal: 1050,
};
